export const IMAGE_SIZE = [16, null, null, 20];
export const IMAGE_MARGIN = 4;

export const SWATCH_PILL_CONTAINER_HEIGHT = '32px';
export const SWATCH_PILL_CONTAINER_HEIGHT_V2 = '24px';
export const SWATCH_IMAGE_SIZE = 14;
export const SWATCH_GAP_SIZE = 2;
export const SWATCH_IMAGE_BORDER_COLOR = 'sys.neutral.border.default';
export const SWATCH_IMAGE_OUTLINE_COLOR = 'sys.neutral.background.default';

export const SWATCH_IMAGE_SIZE_V2 = 12;
export const SWATCH_GAP_SIZE_V2 = 4;
export const SWATCH_IMAGE_BORDER_COLOR_V2 = 'sys.neutral.border.inactive';

export const VISIBLE_SWATCHES_COUNT_V2 = 3;
export const SWATCH_PILL_MAX_WIDTH_V2 = '92px';
